import { useSelector } from 'react-redux';
import React from 'react';
import DynamicContainer from './dynamicComponents/DynamicContainer';
import { createSelector } from '@reduxjs/toolkit';

const selectOverlayComponentsData = createSelector(
	[
		(state) => state.componentConfig,
		(state) => state.sceneLoad.renderScene || false,
		(state) => state.sceneLoad.renderUI || false,
		(state) => state.creatorTools.isEnabled || false,
		(state) => state.creatorTools.hideOverlay || false,
	],
	(componentConfig, renderScene, renderUI, isEnabled, hideOverlay) => {
		const { overlayComponents } = componentConfig || {};
		const { components } = overlayComponents || {};
		const hideForCreatorTools = isEnabled && hideOverlay === 'true';

		return {
			components,
			renderScene,
			renderUI,
			hideForCreatorTools,
		};
	},
);

const OverlayComponents = () => {
	console.log('%c OverlayComponents rerendered', 'color:yellow');
	const { components, renderScene, renderUI, hideForCreatorTools } =
		useSelector(selectOverlayComponentsData);

	return (
		<div className="overlayComponents">
			{!hideForCreatorTools && renderScene && renderUI && (
				<DynamicContainer components={components} />
			)}
		</div>
	);
};

export default OverlayComponents;
